import React from "react";

import { shortenAddress } from "../Utils/Helpers";

import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Heading,
  Text,
  Button,
  Box,
  Stack,
} from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";
import { BoldText } from "../Components/UI/UIHelpers";

interface IPreflightModalTransferProps {
  open: boolean;
  close: () => void;
  sender: string;
  receiver: string;
  value?: number;
  tokenId?: string;
  tokenSymbol: string;
  sourceNetwork: string;
  targetNetwork: string;
  start: () => void;
}

const PreflightModalTransfer: React.FC<IPreflightModalTransferProps> = ({
  open,
  close,
  receiver,
  sender,
  sourceNetwork,
  targetNetwork,
  tokenSymbol,
  value,
  tokenId,
  start,
}: IPreflightModalTransferProps) => {
  return (
    <Drawer onClose={close} isOpen={open} placement="left">
      <DrawerOverlay />
      <DrawerContent minWidth="350px" p="32px">
        <DrawerCloseButton />
        <DrawerHeader p="0px" mb="32px" fontSize="32px">
          Pre-flight check
        </DrawerHeader>
        <DrawerBody p="0px">
          <Box as={Stack} spacing="32px" direction={"column"}>
            <Heading fontSize="20px">
              Please be advised this is an experimental application:
            </Heading>
            <Box as={Stack} spacing="24px" direction={"column"}>
              <Box as={Stack} spacing="16px" direction={"row"}>
                <WarningIcon mt="5px" />
                <Text>
                  You will not be able to cancel the transaction once you submit
                  it.
                </Text>
              </Box>

              <Box as={Stack} spacing="16px" direction={"row"}>
                <WarningIcon mt="5px" />
                <Text>
                  Your transaction could get stuck for an indefinite amount of
                  time.
                </Text>
              </Box>

              <Box as={Stack} spacing="16px" direction={"row"}>
                <WarningIcon mt="5px" />
                <Text>
                  Funds cannot be returned if they are sent to the wrong
                  address.
                </Text>
              </Box>
            </Box>
            <Text>
              I agree and want to send{" "}
              {value && (
                <BoldText>
                  {value} {tokenSymbol}{" "}
                </BoldText>
              )}
              {tokenId && (
                <>
                  <BoldText>{tokenSymbol}</BoldText> with id{" "}
                  <BoldText>{tokenId}</BoldText>{" "}
                </>
              )}
              from <BoldText>{shortenAddress(sender)}</BoldText> on{" "}
              <BoldText>{sourceNetwork}</BoldText> to{" "}
              <BoldText>{shortenAddress(receiver)}</BoldText> on{" "}
              <BoldText>{targetNetwork}</BoldText>.
            </Text>
            <Box>
              <Button onClick={start} size="lg">
                Start Transfer
              </Button>
            </Box>
            <Box>
              <Button variant="outline" onClick={close}>
                Back
              </Button>
            </Box>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default PreflightModalTransfer;
